import * as actionTypes from './actionTypes';

const initialState = {
  eventLogDetails: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_EVENT_LOGGING_DETAILS:
      return { ...state, eventLogDetails: action.payload };
    case actionTypes.SERVICE_ERROR:
      return { ...state, serviceErr: action.payload };
    default:
      return state;
  }
};

export default reducer;
